import requester from '@/lib/axios';
import { MULTIPART_FORM_DATA_HEADERS as headers } from '@/constants';
import { quizAnswersConverter } from '@/data/services/question/quizQuestionServices';
import {
  QuizActivityElement,
  QuizElementPayload,
  QuizElementResponse,
} from '@/models/_deprecated/ActivityElement';
import { QuizQuestion } from '@/models/_deprecated/ActivityProgress';
import {
  convertToFormData,
  jsonFieldConverter,
} from '@/utils/convertToFormData';

const baseUrl = 'quiz-activity';
const nestedUrl = (activityId: number) => `activities/${activityId}/${baseUrl}`;

const converters = {
  question: jsonFieldConverter,
  quizAnswers: quizAnswersConverter,
};

export const getQuizActivity = async (questionId: number) => {
  const { data: quiz } = await requester().get<QuizActivityElement>(
    `${baseUrl}/${questionId}/`,
  );
  return quiz;
};

export type QuizAnswer = QuizQuestion & {
  isCorrect: boolean;
};

export const createQuizQuestionIntoActivity = async (
  activityId: number,
  body: QuizElementPayload,
) => {
  const { data } = await requester().post<QuizElementResponse>(
    `${nestedUrl(activityId)}/`,
    convertToFormData(body, converters),
    { headers },
  );
  return data;
};

export const updateQuizQuestionIntoActivity = async (
  activityId: number,
  id: number,
  changes: QuizElementPayload,
) => {
  const { data } = await requester().patch<QuizElementResponse>(
    `${nestedUrl(activityId)}/${id}/`,
    convertToFormData(changes, converters),
    { headers },
  );
  return data;
};
